// @flow
import styled, { css } from "styled-components";
import { Form, Field } from "react-final-form";
import { Button } from "@nested/component-library";
import { RadioButtons } from "@nested/onboarding-form/src/components/RadioButtons";
import { Results } from "./Results";
import { RichText } from "../RichText/RichText";
import { CurrencyInput } from "../CurrencyInput";
import { calculateResults } from "./calculator";

const RADIO_OPTIONS = [
  {
    label: "I'm a first time buyer",
    value: "FIRST_TIME_BUYER",
  },
  {
    label: "I'm buying my next home",
    value: "MOVING_HOME",
  },
  {
    label: "I'm buying an additional property or second home",
    value: "SECOND_HOME",
  },
];

const buttonStyle = css`
  width: 100%;
  display: block;
  margin-top: 30px;
`;

const Paragraph = styled(RichText)`
  text-align: center;
  margin: 20px 0;
`;

const required = (value: ?boolean) => (value ? undefined : "Required");

type Props = {
  introductionText: PrismicRichText,
  buttonText: string,
};

export const StampDutyForm = ({ introductionText, buttonText }: Props) => (
  <Form
    onSubmit={() => undefined}
    initialValues={{
      price: null,
      buyerStatus: null,
    }}
  >
    {({
      handleSubmit,
      form,
      submitSucceeded,
      submitting,
      hasValidationErrors,
      values,
    }) => {
      if (submitSucceeded) {
        return (
          <Results
            backToForm={() => form.reset(values)}
            // $FlowFixMe
            results={calculateResults(values)}
            buttonText={buttonText}
          />
        );
      }
      return (
        <form onSubmit={handleSubmit}>
          <Paragraph>{introductionText}</Paragraph>
          <Field name="price" validate={required}>
            {({ input, meta }) => (
              <CurrencyInput
                label="Property price"
                id="property-price"
                placeholder="£450,000"
                {...input}
                {...meta}
              />
            )}
          </Field>
          <Field name="buyerStatus" validate={required}>
            {({ input, meta }) => (
              <RadioButtons options={RADIO_OPTIONS} {...input} {...meta} />
            )}
          </Field>
          <Button
            size="large"
            css={buttonStyle}
            type="submit"
            disabled={hasValidationErrors || submitting}
          >
            Calculate savings
          </Button>
        </form>
      );
    }}
  </Form>
);
